import { forwardRef, type Ref, type SVGProps } from "react";

function SvgLocationError(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path fill="#232836" d="M0 0h176v120H0z" />
      <path fill="#fff" d="M-668-2329H650v4236H-668z" />
      <rect
        width={829}
        height={3807}
        x={-575.5}
        y={-2286.5}
        stroke="#9747FF"
        strokeDasharray="10 5"
        rx={4.5}
      />
      <path
        stroke="url(#LocationError_svg__a)"
        strokeWidth={8}
        d="M64 52.121C64 38.799 74.745 28 88 28s24 10.8 24 24.121c0 8.297-4.056 15.968-8.543 21.953-4.516 6.022-9.674 10.61-12.313 12.786a4.91 4.91 0 0 1-6.288 0c-2.64-2.177-7.797-6.764-12.313-12.786C68.056 68.089 64 60.418 64 52.12Z"
        clipRule="evenodd"
      />
      <rect width={39} height={39} x={104.5} y={8.5} fill="#B01921" rx={19.5} />
      <rect width={39} height={39} x={104.5} y={8.5} stroke="#fff" rx={19.5} />
      <path
        stroke="#fff"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M124 22v7m0 3v1"
      />
      <path stroke="#0C1C43" d="M76 97.5h24" />
      <defs>
        <linearGradient
          id="LocationError_svg__a"
          x1={88}
          x2={87.677}
          y1={28}
          y2={73.319}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgLocationError);
export default ForwardRef;
